import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/services/query-keys';
import { useAuthStore } from '@/shared/stores/auth-store';
import { fetchAccounts, fetchAccount, fetchMetaPixels } from './accounts-api';

export function useAccounts() {
  const orgId = useAuthStore((state) => state.orgId);
  return useQuery({
    queryKey: queryKeys.accounts.list(orgId ?? 'none'),
    queryFn: () => fetchAccounts(orgId!),
    enabled: !!orgId,
  });
}

export function useAccount(id: string) {
  const orgId = useAuthStore((state) => state.orgId);
  return useQuery({
    queryKey: queryKeys.accounts.detail(id, orgId ?? undefined),
    queryFn: () => fetchAccount(orgId!, id),
    enabled: !!id && !!orgId,
  });
}

/**
 * Pixels the Meta ad account can see. Fetched on-demand by the wizard
 * Conversion step. Pixels rarely change, so we hold the result for 5min.
 */
export function useMetaPixels(adAccountId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.accounts.metaPixels(adAccountId ?? 'none'),
    queryFn: () => fetchMetaPixels(adAccountId!),
    enabled: !!adAccountId,
    staleTime: 5 * 60 * 1000,
  });
}
